import React from 'react';
import PropTypes from 'prop-types';

import { LOCALE } from '../../env';
import hero1 from '../../../public/images/avatars/hero1_conv_icon.png';
import hero2 from '../../../public/images/avatars/hero2_conv_icon.png';
import hero3 from '../../../public/images/avatars/hero3_conv_icon.png';
import hero3ad from '../../../public/images/avatars/hero3_ad_icon.png';
import heroine1 from '../../../public/images/avatars/heroine1_conv_icon.png';
import heroine2 from '../../../public/images/avatars/heroine2_conv_icon.png';
import heroine3 from '../../../public/images/avatars/heroine3_conv_icon.png';
import heroine3ad from '../../../public/images/avatars/heroine3_ad_icon.png';

const items = [
  { id: 'hero1_conv', imageSrc: hero1 },
  { id: 'hero2_conv', imageSrc: hero2 },
  { id: 'hero3_conv', imageSrc: (LOCALE === 'gh') ? hero3ad : hero3 },
  { id: 'heroine1_conv', imageSrc: heroine1 },
  { id: 'heroine2_conv', imageSrc: heroine2 },
  { id: 'heroine3_conv', imageSrc: (LOCALE === 'gh') ? heroine3ad : heroine3 },
];

const imageSrc = (avatarFileName) => {
  return items.find(i => i.id === avatarFileName);
};

const Avatar = ({ avatarFileName, nickname, handleProfile }) => {
  const item = imageSrc(avatarFileName);
  const AvatarPng = item ? item.imageSrc : '';
  return AvatarPng && nickname ? (
    <p className="avater" >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" onClick={handleProfile}>
        <img src={AvatarPng} alt="avatar" width="200" height="240" />
      </a>
      <span>{nickname}</span>
    </p>
  ) : (
    ''
  );
};

Avatar.propTypes = {
  avatarFileName: PropTypes.string,
  nickname: PropTypes.string,
  handleProfile: PropTypes.func.isRequired,
};

Avatar.defaultProps = {
  avatarFileName: 'heroin1_conv',
  nickname: 'ニックネーム',
};

export default Avatar;
